import AsyncSelect from "react-select/async";
import { useCallback } from 'react';
import { SearchFieldStyles } from "./SearchFieldStyles";
import servOcupante from "../../services/login/servOcupante";
import { useSelector } from "react-redux";

const OcupantesSearchField = ({ field, id, setOpenError, setErrorMessage, disabled = false, onKeyDown, className = "", menuPortalTarget, menuPosition, styles: extraStyles }) => {
    const user = useSelector(state => state.user);

    const loadOcupantes = async (inputValue) => {
        try {
            const response = await servOcupante.listar(user.codigoUsuario, inputValue);

            let data = response.Content.map(mapResponseToValuesAndLabels);

            return data;

        } catch (err) {
            setOpenError(true);
            setErrorMessage(err?.response?.data?.Message);
        }
    }

    const mapResponseToValuesAndLabels = (data) => {
        const formatarCNPJ = (inscricao) => {
            if (!inscricao) return '';

            const numeros = inscricao.replace(/\D/g, '');

            return numeros.replace(
                /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
                '$1.$2.$3/$4-$5'
            );
        };

        const inscricaoFormatada = formatarCNPJ(data.Inscricao);

        return {
            value: data.Id,
            label: `${inscricaoFormatada} - ${data.Nome}`,
            codigo: data.Codigo,
            CodigoUsoMutuo: data?.CodigoUsoMutuo
        }
    }

    return (
        <AsyncSelect
            id={id}
            cacheOptions
            placeholder="Selecione um ocupante"
            loadOptions={loadOcupantes}
            defaultOptions
            isDisabled={disabled}
            styles={extraStyles ? { ...SearchFieldStyles, ...extraStyles } : SearchFieldStyles}
            {...field}
            onKeyDown={onKeyDown}
            className={className}
            menuPortalTarget={menuPortalTarget}
            menuPosition={menuPosition}
        />
    )
}

export { OcupantesSearchField }